import { computed, type ComputedRef } from 'vue';

/**
 * The ids returned by `getIds`, as the very same array while they stay equal:
 * a watcher on it only fires when the ids really change, even though `getIds`
 * builds a fresh array on every clock tick or vehicle poll.
 */
export function useStableIds(getIds: () => Array<string>): ComputedRef<Array<string>> {
  return computed<Array<string>>(previousIds => {
    const ids = getIds();
    const unchanged =
      ids.length === previousIds?.length && ids.every((id, index) => id === previousIds[index]);
    return unchanged ? previousIds : ids;
  });
}
